import clsx from 'clsx';

const TONE_TO_CLASS = {
  petrol: 'brand-pill-petrol',
  teal: 'brand-pill-teal',
  orange: 'brand-pill-orange',
  green: 'brand-pill-green',
  slate: 'brand-pill-slate',
} as const;

type Tone = keyof typeof TONE_TO_CLASS;

interface Props {
  tone?: Tone;
  children: React.ReactNode;
}

/**
 * Status pill. Uses categorical accents (not decorative): map domain status to a
 * tone via the helpers below.
 */
export function Pill({ tone = 'slate', children }: Props) {
  return <span className={clsx('brand-pill', TONE_TO_CLASS[tone])}>{children}</span>;
}

export function queueTone(status: string): Tone {
  switch (status) {
    case 'Open':
      return 'orange';
    case 'InReview':
      return 'teal';
    case 'Resolved':
      return 'green';
    case 'Dismissed':
      return 'slate';
    default:
      return 'slate';
  }
}

export function lifecycleTone(status: string): Tone {
  switch (status) {
    case 'Pending':
      return 'orange';
    case 'Confirmed':
      return 'teal';
    case 'Executing':
      return 'petrol';
    case 'Completed':
      return 'green';
    case 'Failed':
      return 'slate';
    default:
      return 'slate';
  }
}

export function dealTone(status: string): Tone {
  switch (status) {
    case 'Active':
      return 'green';
    case 'Evaluation':
      return 'teal';
    case 'Killed':
      return 'slate';
    case 'Exited':
      return 'petrol';
    default:
      return 'slate';
  }
}
